/** "$1,234.50" → 1234.5. "(1,234.00)" or "-$1,234" → negative. Blank → null. Unparseable → undefined. */
export function parseMoney(raw: string | number | null | undefined): number | null | undefined {
  if (typeof raw === 'number') return Number.isFinite(raw) ? Math.round(raw * 100) / 100 : undefined;
  let s = (raw ?? '').trim();
  if (!s) return null;
  let neg = false;
  if (/^\(.*\)$/.test(s)) { neg = true; s = s.slice(1, -1); }
  s = s.replace(/[\s,]/g, '');
  if (s.startsWith('-')) { neg = !neg; s = s.slice(1); }
  s = s.replace(/^(AU)?\$/i, '');
  if (s.startsWith('-')) { neg = !neg; s = s.slice(1); }
  if (!/^\d+(\.\d+)?$|^\.\d+$/.test(s)) return undefined;
  const v = Math.round(Number(s) * 100) / 100;
  return neg ? -v : v;
}

/** Whole-dollar AUD, as the prototype shows it: "$12,500". */
export function money(v: number | string | null | undefined): string {
  const n = Number(v || 0);
  return (n < 0 ? '-$' : '$') + Math.abs(n).toLocaleString('en-AU', { maximumFractionDigits: 0 });
}

/** Short money for tiles and bars: $1.25M, $45k, or whole dollars under $10k. */
export function compact(v: number): string {
  return v >= 1e6 ? '$' + (v / 1e6).toFixed(2) + 'M' : v >= 1e4 ? '$' + Math.round(v / 1e3) + 'k' : money(v);
}

export function sum<T>(list: T[], key: keyof T): number {
  return list.reduce((t, j) => t + Number(j[key] || 0), 0);
}
